import { ObservableArray, View } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerSideDataLoader } from "uicomponents";
import { product, ProductManipulationViewModel } from "./productManipulation-viewModel"

export class ProductManipulationView extends View<ProductManipulationViewModel>{
    GetViewUniqueId(): string {
        return "V-E10766F9-3593-4C65-B3BD-7013B9748582"
    }
    loadHtml(): string {
        let element = require('./productManipulation.html').default;
        let style = require('./productManipulation.less');
        return element;
    }
    constructor() {
       super();
    }

    public set products(v: ObservableArray<product>) { this._products = v; } public get products(): ObservableArray<product> { return this._products;} private _products: ObservableArray<product>;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;

    addNew(){
        this.dataContext.addNew();
    }
}
